
class Events {
    constructor() {
        this.title = null
        this.prevBtn = null
        this.nextBtn = null
        this.pageIndicator = null
        this.page = 1
        this.maxPage = 0
        this.count = 0

        this.locked = false

        this.title = $("#events-menu-title");
        this.prevBtn = $("#events-menu-prev-btn");
        this.nextBtn = $("#events-menu-next-btn");
        this.pageIndicator = $("#events-menu-page");

        this.count = parseInt($("#events-menu-count").text());
        this.maxPage = Math.ceil(this.count / 5);

        var offset = parseInt(this.pageIndicator.text());
        if (offset > 1) this.page = Math.ceil(offset / 5);
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    previous() {
        var that = this;
        if (this._locked || this.page - 1 < 1) return;
        this._lock();

        that.page --;

        $.ajax({
            url: "/profile/get-header-events/", dataType: 'json', type: 'post',
            data: {page: this.page},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    $(".events-menu-event").remove();
                    $("#events-menu").prepend(data.view);
                    $(".events-menu-event .marquee").each(function (k, v) {$(v).marquee();});

                    that.pageIndicator.html(((that.page - 1) * 5 + 1) + '-' + Math.min((that.page * 5), that.count));
                    if (that.page <= 1) {
                        //if (!that.prevBtn.hasClass("disabled")) that.prevBtn.addClass("disabled");
                    }
                }
                that._unlock();
            }
        });
    }

    next() {
        var that = this;
        if (this._locked || this.page + 1 > this.maxPage) return;
        this._lock();

        that.page ++;

        $.ajax({
            url: "/profile/get-header-events/", dataType: 'json', type: 'post',
            data: {page: this.page},
            success: function(data) {
                if (data && data.success != undefined && data.success) {
                    $(".events-menu-event").remove();
                    $("#events-menu").prepend(data.view);
                    $(".events-menu-event .marquee").each(function (k, v) {$(v).marquee();});

                    that.pageIndicator.html(((that.page - 1) * 5 + 1) + '-' + Math.min((that.page * 5), that.count));
                    if (that.page >= that.maxPage) {
                        //if (!that.nextBtn.hasClass("disabled")) that.nextBtn.addClass("disabled");
                    }
                }
                that._unlock();
            }
        });
    }
}

export { Events }
